import BackToAdminCentre from './BackToAdminCentre'

export default BackToAdminCentre



// WEBPACK FOOTER //
// ./src/components/BackToAdminCentre/index.js